import { render, staticRenderFns } from "./DataTableToggleColumns.vue?vue&type=template&id=46b25cd2&scoped=true"
import script from "./DataTableToggleColumns.vue?vue&type=script&lang=js"
export * from "./DataTableToggleColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b25cd2",
  null
  
)

export default component.exports